import Axios, { AxiosResponse } from "axios";
import { showError } from "../pages/form-buttons-controls-rest";

export declare interface AppResponse<T = unknown> {
  error: boolean;
  errors: Array<string>;
  messages: Array<string>;
  data?: T;
}

Axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
Axios.defaults.headers.common["X-Requested-Model-Format"] = "PlainJSON";

class Ajax {
  private checkRedirection(response: AxiosResponse): void {
    // console.debug('checking redirection header', response.headers)
    if ("x-redirect-to" in response.headers) {
      console.warn("Session ended. Reloading page...");
      window.location.reload();
    }
  }

  private processResponse<T>(response: AxiosResponse): Promise<AppResponse<T>> {
    this.checkRedirection(response);

    return response.data;
  }

  private async processError<T>(error: string): Promise<AppResponse<T>> {
    return {
      error: true,
      errors: [error],
      data: {} as T,
      messages: [],
    };
  }

  async post<T, B = unknown>(url: string, data?: B): Promise<AppResponse<T>> {
    try {
      const response = await Axios.post(url, data);
      return this.processResponse(response);
    } catch (error) {
      return this.processError(error);
    }
  }

  async get<T, B = unknown>(url: string, config?: B): Promise<AppResponse<T>> {
    try {
      const response = await Axios.get(url, config);
      return this.processResponse(response);
    } catch (error) {
      return this.processError(error);
    }
  }

  async htmlPost<B = unknown>(url: string, data: B): Promise<string | null> {
    try {
      const response = await Axios.post(url, data, {});
      this.checkRedirection(response);
      return response.data;
    } catch (error) {
      showError(error, error.response.data);
      return null;
    }
  }
}

export default new Ajax();
